export const MENU = {
  HOME: 'home',
  BROADCAST: 'broadcast',
  LIVE: 'live',
  LIVE_NEW: 'live_new',
  MOVIE: 'movie',
  GLOBAL: 'global',
  PLAYY: 'palyy',
  CLIP: 'clip',
  LIST: 'list',
  MOVIE_17: 'movie_17',
  MOVIE_18: 'movie_18',
  BASEBALL: 'baseball',
  CATEGORY: 'category',
  MY: 'my',
}

export const GNB_MENU_LIST = [
  MENU.HOME,
  MENU.BROADCAST,
  MENU.LIVE,
  MENU.MOVIE,
  MENU.GLOBAL,
  MENU.PLAYY,
]

export const CONTENT_TYPE = {
  VOD: 'vod',
  LIVE: 'live',
  MOVIE: 'movie',
  GLOBAL: 'global',
}

export const UI_CODE = {
  HOME: 'GN51',
  BROADCAST: 'GN2',
  LIVE: 'GN54',
  MOVIE: 'GN16',
  GLOBAL: 'GN12',
  PLAYY: 'GN5',
  CLIP: 'GN6',
  MOVIE_17: 'GN17',
  MOVIE_18: 'GN18',
  BASEBALL: 'GN9',
  MY: 'GN53',
}

export const EVENT_TYPE = {
  ON_CLICK: 'on-click',
  ON_CONTENT: 'on-content',
  ON_DISPLAY: 'on-display',
  ON_VIEW_MORE: 'on-viewmore',
  ON_NAVIGATION: 'on-navigation',
  ON_DETAIL: 'on-detail',
  ON_MOVE_TAB: 'on-movetab',
  ON_INSTANT_PLAY: 'on-instantplay',
  ON_ZZIM: 'on-zzim',
  OFF_ZZIM: 'off-zzim',
}

export const MULTI_SECTION_LIST_ACTIONS = {
  FETCH: 'FETCH_MULTI_SECTION_LIST',
  SET: 'SET_MULTI_SECTION_LIST',
}

export const DEVICE_TYPE = new Map([['pc', '1']])

// 계정 연결을 위한 provider 목록
export const PROVIDER_LIST = [
  {
    id: 1,
    type: 'wavve',
    title: 'Wavve',
  },
  {
    id: 15,
    type: 'facebook',
    title: 'Facebook',
  },
  {
    id: 16,
    type: 'kakao',
    title: 'Kakao',
  },
  {
    id: 17,
    type: 'naver',
    title: 'Naver',
  },
  {
    id: 20,
    type: 'tid',
    title: 'T-ID',
  },
  {
    id: 21,
    type: 'apple',
    title: 'Apple',
  },
]

export const TOAST_TEXT = 'toast_text'

export const SEARCH_TAB_LIST = [
  {
    title: '전체',
    url: '전체',
    type: 'all',
    subType: { mtype: 'all' },
    isBeta: false,
  },
  {
    title: '프로그램',
    url: '프로그램',
    type: 'program',
    subType: {},
    isBeta: false,
  },
  { title: '에피소드', url: 'VOD', type: 'vod', subType: {}, isBeta: false },
  // { title: '영화', url: '영화', type: 'movie', isBeta: false },
  {
    title: '영화',
    url: '영화',
    type: 'movie',
    subType: { mtype: 'svod' },
    isBeta: false,
  },
  {
    title: '영화플러스',
    url: '영화플러스',
    type: 'movie',
    subType: { mtype: 'ppv' },
    isBeta: false,
  },
  { title: 'LIVE', url: 'LIVE', type: 'live', subType: {}, isBeta: false },
  {
    title: '에디터Pick',
    url: '에디터Pick',
    type: 'theme',
    subType: {},
    isBeta: false,
  },
  {
    title: '고객지원',
    url: '고객지원',
    type: 'customer',
    subType: {},
    isBeta: false,
  },
]

export const SEARCH_TAG_TAB_LIST = [
  { title: '전체', type: 'all', tagCategory: 'broadcast' },
  {
    title: '프로그램',
    url: '프로그램',
    type: 'program',
    tagCategory: 'broadcast',
  },
  { title: '에피소드', url: 'VOD', type: 'vod', tagCategory: 'broadcast' },
  { title: '전체', type: 'all', tagCategory: 'movie' },
  {
    title: '영화',
    url: '영화',
    type: 'movie',
    mtype: 'svod',
    tagCategory: 'movie',
  },
  {
    title: '영화플러스',
    url: '영화플러스',
    type: 'movie',
    mtype: 'ppv',
    tagCategory: 'movie',
  },
]

export const MY_BAND_EMPTY_MESSAGE = [
  { title: '전체 시청내역', emptyMessage: '시청내역이 없어요' },
  { title: '관심 영화', emptyMessage: '관심 영화가 없어요' },
  { title: '관심 에디터Pick', emptyMessage: '관심 에디터Pick이 없어요' },
  { title: '관심 프로그램', emptyMessage: '관심 프로그램이 없어요' },
]
export const MY_BAND_DEFAULT_EMPTY_MESSAGE = '테이터가 없습니다.'

export const EVENT_TYPE_MOUSE_ENTER = '$MOUSE_ENTER'
export const EVENT_TYPE_MOUSE_LEAVE = '$MOUSE_LEAVE'

export const KBO_TEAM_LIST = [
  {
    name: 'SSG',
    code: 'SK',
    image: 'https://annex-sport-img.wavve.com/TEAM/S_SK_oItqn.png',
  },
  {
    name: 'KIA',
    code: 'HT',
    image: 'https://annex-sport-img.wavve.com/TEAM/S_HT_RyjIK.png',
  },
  {
    name: '키움',
    code: 'WO',
    image: 'https://annex-sport-img.wavve.com/TEAM/nexen2.png',
  },
  {
    name: '두산',
    code: 'OB',
    image: 'https://annex-sport-img.wavve.com/TEAM/doosan.png',
  },
  {
    name: '롯데',
    code: 'LT',
    image: 'https://annex-sport-img.wavve.com/TEAM/lotte.png',
  },
  {
    name: '삼성',
    code: 'SS',
    image: 'https://annex-sport-img.wavve.com/TEAM/samsung.png',
  },
  {
    name: 'NC',
    code: 'NC',
    image: 'https://annex-sport-img.wavve.com/TEAM/nc.png',
  },
  {
    name: 'LG',
    code: 'LG',
    image: 'https://annex-sport-img.wavve.com/TEAM/lg.png',
  },
  {
    name: 'kt',
    code: 'KT',
    image: 'https://annex-sport-img.wavve.com/TEAM/kt.png',
  },
  {
    name: '한화',
    code: 'HH',
    image: 'https://annex-sport-img.wavve.com/TEAM/hanwha.png',
  },
]

export const SNS_TYPE_FACEBOOK = 'facebook'
export const SNS_TYPE_KAKAO = 'kakao'
export const SNS_TYPE_NAVER = 'naver'
export const SNS_TYPE_T_ID = 'tid'
export const SNS_TYPE_APPLE = 'apple'

export const SNS_TYPE_LIST = [
  SNS_TYPE_FACEBOOK,
  SNS_TYPE_KAKAO,
  SNS_TYPE_NAVER,
  SNS_TYPE_T_ID,
  SNS_TYPE_APPLE,
]

export const MODAL_STANDARD_CONFIRM = 'MODAL_STANDARD_CONFIRM'
export const FIRST_MONTH_PROMOTION_CONFIRM = 'FIRST_MONTH_PROMOTION_CONFIRM'

export const MODAL_STANDARD = 'MODAL_STANDARD'
export const CONSENT_PROMOTION_LAYER_POPUP = 'CONSENT_PROMOTION_LAYER_POPUP'
export const ADULT_LAYER_POPUP = 'ADULT_LAYER_POPUP'

export const ADULT_CHECK_TYPE_CONTENT = 'adult_watch_check'
export const ADULT_CHECK_TYPE_DOWNLOAD = 'adult_download_check'

export const SHOW_ALARM_POPUP = '$SHOW_ALARM_POPUP'
export const HIDE_ALARM_POPUP = '$HIDE_ALARM_POPUP'
export const ALARM_POPUP_TYPE_ALL = 'ALARM_POPUP_TYPE_ALL'
export const ALARM_POPUP_TYPE_LIVE = 'ALARM_POPUP_TYPE_LIVE'

export const SET_CURRENT_MENU = 'SET_CURRENT_MENU'
export const SET_CURRENT_GNB = 'SET_CURRENT_GNB'
export const SHOW_LOADING_PROGRESS = 'SHOW_LOADING_PROGRESS'
export const HIDE_LOADING_PROGRESS = 'HIDE_LOADING_PROGRESS'

export const SEARCH_HISTORY_LOCAL_STORAGE_KEY = 'search-history'

export const CLOSE_SEARCH_POPUP_EVENT = '$CLOSE_SEARCH_POPUP'
export const OPEN_SEARCH_POPUP_EVENT = '$OPEN_SEARCH_POPUP'

export const CATEGORY_BROAD_CAST = 'vodgenre'
export const CATEGORY_MOVIE = 'moviegenre'
export const CATEGORY_MOVIE_SVOD = 'moviegenre_svod'
export const CATEGORY_MOVIE_PLUS = 'moviegenre_ppv'

export const UPDATE_MY_POOQ_CONTENT = 'update_mypooq_contents'
export const UPDATE_PAGING_CONTENT = 'update_paging_contents'
export const UPDATE_MAIN_LAYOUT_CONTENT = 'update_main_layout_content'
export const UPDATE_EVENT_LAYOUT_CONTENT = 'update_event_layout_content'
export const UPDATE_EVENT_LIST_CONTENT = 'update_event_list_content'
export const UPDATE_SEARCH_CONTENT = 'update_search_content'
export const UPDATE_VOD_ALL_LIST_CONTENT = 'update_vod_all_list_content'
export const UPDATE_PLAYER_INFO = 'update_player_info'
export const ON_DISPLAY_BAND = 'on_display_multi_band'
export const ON_CLICK_CELL = 'on_click_cell'
export const FLUSH_EVENT = 'flush_event'
export const DOMAIN = location.hostname
  .replace('www.', '')
  .replace('dev-', '')
  .replace('qa-', '')
export const GENRE_CODE_GLOBAL_DRAMA = '09'

export const UPDATE_CONTENT_INFO_EVENT = 'updateContentInfo'
export const LOGIN_SUCCESS_EVENT = 'loginSuccess'
export const PLAYER_UPDATE_EVENT = 'playerUpdate'

export const INSTANT_PLAYER_IS_MUTE_KEY = 'instant_player_is_mute'
export const SERVICE_LOCATION_KEY = 'service_location_key'
export const SERVICE_LOCATION_AMAZON = 'aws'
export const SERVICE_LOCATION_AZURE = 'azure'
export const SERVICE_LOCATION_AZURE_FOR_PLAYER = 'az'
// export const UPDATE_JSON_URL = 'https://pooq3-static-json.wavve.com/service/update/update_pc.json'
// export const UPDATE_JSON_URL_TEST = 'https://pooq3-static-json.wavve.com/serviceTest/updateTest/update_pc.json'
export const EMERGENCY_JSON_URL =
  'https://pooq3-static-json.wavve.com/service/update/update_pc.json'
// export const EMERGENCY_JSON_URL_TEST = 'https://pooq3-static-json.wavve.com/serviceTest/updateTest/update_pc.json'
export const ABOUT_BLANK = 'about:blank'

export const PROMOTION_CODE_KEY = 'promotioncode'

export const KNOCK_TRACE_KEY = 'knock_trace_key'

const today = new Date()
export const CONFIRM_EMERGENCY =
  '' + today.getFullYear() + (today.getMonth() + 1) + today.getDate()

// search
export const CHANGE_FILTER = 'changeFilter'
export const MOVE_TO_DETAIL_TAB = 'move_to_detail_tab'
export const DOWNLOAD_LAYOUT = 'download-layout'

export const SEARCH_INPUT_FOCUS = 'search_input_focus'
export const SEARCH_AGAIN_INPUT_FOCUS = 'search_again_input_focus'
export const SEARCH_TYPING_QUERY = 'search_typing_query'
export const SEARCH_RESULT_QUERY = 'search_result_query'
export const SEARCH_HEADER_TAG_LAYER = 'search_header_tag_layer'
export const SEARCH_SAME_QUERY = 'search_same_query'

export const STORAGE_ROUTER_HISTORY = 'router_history'
export const STORAGE_TRANSACTION_KEY = 'transaction_key'

export const URL_IMG_DOMAIN = 'image.wavve.com'
export const URL_WAVVE = 'www.wavve.com'
export const URL_WAVVE_DEV = 'dev-www.wave.com'
export const URL_WAVVE_QA = 'qa-www.wavve.com'
export const URL_WAVVE_STG = 'stg-wavve.com'

// buttons
export const CTA_ICON_AUTO_PLAY = 'icon_autoplay'
export const CTA_ICON_INFORMATION = 'icon_information'
